const accounts = {
  email: "me@rohanbenstead.com",
  github: "https://github.com/rbenstead",
  linkedin: "https://www.linkedin.com/in/rohanbenstead/",
};

export default accounts;
